/**
 * 모바일 관리자 공용 상수 — 접수(Order)·기사(Member) 카드가 함께 쓴다.
 * (Order 가 Member 를 import 하므로 상수는 별도 모듈로 둬 순환참조를 피한다)
 */

// 업종 색면 — /adm 의 업종 셀 배경색 그대로 (F/Order/ListTable.js CAR_TYPE_COLORS)
export const CAR_TYPE_BG = {
    '스카이': '#FFFFFF', '사다리': '#00FFFF', '크레인': '#FFCEB7',
    '지게차': '#FFFF80', '굴삭기': '#D2D2FF', '리프트': '#EAD5FF',
};

// 본사 뱃지 색 — /adm 기사목록 _bonsaCls (bx-badge-*) 와 같은 팔레트
export const BONSA_CLS = {
    'bx-badge-gray': 'ma-bx-gray',   // 012 장비불러
    'bx-badge-ss':   'ma-bx-ss',     // 019 삼성
    'bx-badge-lg':   'ma-bx-lg',     // 020 LG
    'bx-badge-all':  'ma-bx-all',    // 그 외
};

/**
 * 방금 편집을 켠 블록을 **탭바 바로 아래에 붙여** 올린다.
 *
 * 시트 중간의 블록에서 [수정] 을 누르면 입력칸 절반이 접힌 채로 열려, 켜자마자 손으로 다시
 * 끌어올려야 했다.
 *
 * 화면 맨 위가 아니라 `sticky` 기준이다 — 탭바(정보·상담·기록·관리)가 스크롤 컨테이너 위에
 * 붙어 있어서, 컨테이너 top 에 맞추면 블록 머리가 탭바 뒤로 들어가 가려진다.
 *
 * 두 프레임에 걸쳐 맞춘다. 첫 프레임에는 탭바가 아직 안 붙어 있을 수 있어(스크롤 위쪽에 있을 때)
 * 잰 값이 틀리는데, 한 번 굴린 뒤 다시 재면 붙은 자리 기준이라 맞는다.
 *
 * @param {Element} el      맨 위로 올릴 블록
 * @param {Element} sticky  위에 붙어 있는 요소(탭바). 없으면 컨테이너 top 기준
 * @param {number}  gap     붙이고 남길 틈(px)
 */
export function scrollSecTop(el, sticky = null, gap = 6) {
    if (!el) return;

    // 조상 중 실제로 스크롤되는 요소. 그 순간 내용이 짧아 스크롤이 아직 없으면 못 찾는데,
    // 그때는 시트의 스크롤 주인(BS content-area)을 직접 집는다.
    let sc = el.parentElement;
    while (sc && !(sc.scrollHeight > sc.clientHeight + 4
        && /auto|scroll/.test(getComputedStyle(sc).overflowY))) sc = sc.parentElement;
    if (!sc) sc = el.closest('.content-area');
    if (!sc) return;

    const step = () => {
        const top = sticky
            ? sticky.getBoundingClientRect().bottom
            : sc.getBoundingClientRect().top;
        sc.scrollTop += el.getBoundingClientRect().top - top - gap;
    };
    requestAnimationFrame(() => { step(); requestAnimationFrame(step); });
}

/**
 * 늦게 붙는 내용(ajax 로 오는 장비 목록·카셀렉트 옵션) 때문에 어긋난 스크롤을 다시 맞춘다.
 * 켤 때 한 번 맞춰도 그 뒤에 높이가 늘면 블록 머리가 탭바 위로 밀려 올라간다.
 */
export function reScrollSecTop(el, sticky = null, gap = 6) {
    if (!el) return;
    setTimeout(() => scrollSecTop(el, sticky, gap), 60);
}
